import React from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
} from "@radix-ui/react-popover";
import {
  FaUser,
  FaCaretDown,
  FaCaretUp,
  FaSignOutAlt,
  FaCog,
} from "react-icons/fa";
import logo from "../../dchhs-notag-22-white.png";

const TopBarContainer = styled.div`
  position: sticky;
  top: 0;
  z-index: 1000;

  display: flex;
  justify-content: space-between;
  /* align-items: center; */

  padding: 10px 20px;
  background-color: ${({ theme }) => theme.branding.bannerColor};
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: flex-start;
  }

  @media (max-width: 480px) {
    padding-top: 10px;
  }
`;

const LeftContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 600px) {
    flex-direction: column;
    /* padding: 10px 0; */
  }

  @media (max-width: 480px) {
    /* padding: 10px 0; */
  }
`;

const LogoImg = styled.img`
  margin-right: 10px;

  @media (max-width: 600px) {
    margin-right: 0;
    margin-bottom: 10px;
  }
`;

const BannerText = styled.div`
  font-size: 1.2rem;
  color: ${({ theme }) => theme.branding.textColor};
  font-weight: bold;
`;

const UserMenu = styled.div`
  /* position: relative; */
  display: flex;
  align-items: center;
  cursor: pointer;

  span {
    margin-left: 10px;
  }
`;

const MenuContent = styled(PopoverContent)`
  background-color: ${({ theme }) => theme.branding.color};
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;

  /* width: 200px; */
  /* border-radius: 8px; */
  /* padding: 10px; */
  /* border-style: none; */
`;

const MenuItem = styled.div`
  padding: 10px;
  cursor: pointer;
  transition: background-color 0.3s;
  color: ${({ theme }) => theme.colors.primary};

  &:hover {
    background-color: ${({ theme }) => theme.branding.bgColorHover};
  }
`;

const UserButton = styled.button`
  display: flex;
  align-items: center;
  padding: 10px;
  /* background-color: transparent; */
  background-color: ${({ theme }) => theme.branding.color};
  color: ${({ theme }) => theme.colors.primary};

  border: none;
  cursor: pointer;
  outline: none;
  font-size: 1rem;

  svg {
    margin-left: 5px;
  }
`;

function TopBar({ userName, onLogout }) {
  const [isOpen, setIsOpen] = React.useState(false);

  const navigate = useNavigate();

  return (
    <TopBarContainer>
      <LeftContainer>
        <LogoImg src={logo} alt="Logo" width="300px" />
        <BannerText>Dallas County PHEP Record Recovery Portal</BannerText>
      </LeftContainer>

      {userName && (
        <UserMenu>
          <Popover open={isOpen} onOpenChange={setIsOpen}>
            <PopoverTrigger asChild>
              <UserButton>
                <FaUser />
                <b>
                  <span>{userName}</span>
                </b>
                {isOpen ? <FaCaretUp /> : <FaCaretDown />}
              </UserButton>
            </PopoverTrigger>
            <MenuContent sideOffset={0} align="end">
              <MenuItem
                onClick={() => {
                  navigate("/requests");
                  setIsOpen(false);
                }}
              >
                <FaCog /> Request History / Historial Solicitudes
              </MenuItem>
              <MenuItem onClick={onLogout}>
                <FaSignOutAlt /> Logout / Salir
              </MenuItem>
            </MenuContent>
          </Popover>
        </UserMenu>
      )}
    </TopBarContainer>
  );
}

export default TopBar;
